import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as httpUtil from "@/utils/httpUtil";
const interfaces = [{
  //desc: "退出登录",
  method: "post",
  name: "logout",
  url: "/account/logout"
}, {
  method: "postExFile",
  name: "exportSourcePPT",
  url: "/activity/contribute/exportSourcePPT"
}];
function exportsRender(interfacesArr) {
  const resultExports = {};
  interfacesArr.map(item => {
    resultExports[item.name] = data => {
      return httpUtil[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}
export default exportsRender(interfaces);